module.exports = __webpack_public_path__ + "img/emp1-2.ef533e1e.jpg";